import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SaleFormService {
  private _saleSuccess: boolean = false;
  private formData: any = {};

  setStepData(step: string, data: any) {
    this.formData[step] = data;
  }

  getStepData(step: string): any {
    return this.formData[step];
  }

  getAllData(): any {
    return this.formData;
  }

  clearData() {
    this.formData = {};
    this._saleSuccess = false;
  }

  get saleSuccess(): boolean {
    return this._saleSuccess;
  }

  set saleSuccess(value: boolean) {
    this._saleSuccess = value;
  }
}
